import * as React from 'react';

import { InjectedFormProps, reduxForm } from 'redux-form';

import './Form.scss';

interface FormProps {
  className?: string;
  onSubmit: MSExecAtPriorityFunctionCallback;
}

const FormComponent: React.StatelessComponent<FormProps & InjectedFormProps<{}, FormProps>>
  = ({ children, className, handleSubmit, onSubmit }) => {
    const onSubmitForm = handleSubmit && handleSubmit(onSubmit);
    return (
      <form className={className} onSubmit={onSubmitForm}>
        {children}
      </form>
    );
  };

export const Form = reduxForm<{}, FormProps>({
  enableReinitialize: true
})(FormComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Form.tsx